import { AudiencePlatformItem, AudienceRecommendationRecommendationItem, CountryItem } from '@digiseg-labs/api-client';
import { Box, Skeleton } from '@radix-ui/themes';
import AudienceRecommendationModal from './AudienceRecommendationModal';
import React from 'react';

export type ConversationItem = {
  sender: 'user' | 'ai';
  message: string;
  recommendations?: AudienceRecommendationRecommendationItem[];
  isLoading?: boolean;
};

type ConversationListProps = {
  conversation: ConversationItem[];
  countries: CountryItem[]; 
  platforms: AudiencePlatformItem[];
  selectedCountry: CountryItem | undefined;
  selectedPlatform: AudiencePlatformItem | undefined;
  onCountrySelected: (c: CountryItem | undefined) => void;
  onPlatformSelected: (p: AudiencePlatformItem | undefined) => void;
  userEndRef?: React.RefObject<HTMLDivElement>; 
};

const ConversationList: React.FC<ConversationListProps> = ({
  conversation,
  countries,
  platforms,
  selectedCountry,
  selectedPlatform,
  onCountrySelected,
  onPlatformSelected,
  userEndRef,
}) => {
  const lastUserIndex = [...conversation].reverse().findIndex(m => m.sender === 'user');
  const lastUserMessageIndex = lastUserIndex !== -1 ? conversation.length - 1 - lastUserIndex : -1;

  return (
    <>
      {conversation.map((msg, index) => {
        const isUser = msg.sender === 'user';
        const isLastUser = index === lastUserMessageIndex;

        return (
          <Box
            key={index}
            ref={isUser && isLastUser ? userEndRef : null}
            className={`conversation-message${isUser ? ' conversation-message--user' : ''}`}
          >
            <strong>{isUser ? 'You:' : 'AI:'}</strong>
            <div className="preformatted-text">
              {msg.isLoading ? <Skeleton /> : msg.message}
            </div>

            {!isUser && !msg.isLoading && msg.recommendations && (
              <div className="conversation-recommendations">
                {msg.recommendations.map((rec, i) => (
                  <div key={i} className="conversation-recommendation">
                    <AudienceRecommendationModal
                      audienceItem={rec.audience}
                      audienceCode={rec.audience.code}
                      countries={countries}
                      platforms={platforms}
                      selectedCountry={selectedCountry}
                      selectedPlatform={selectedPlatform}
                      onCountrySelected={onCountrySelected}
                      onPlatformSelected={onPlatformSelected}
                    />
                    <p><b>Reason:</b> {rec.reason}</p>
                  </div>
                ))}
              </div>
            )}
          </Box>
        );
      })}
    </>
  );
};

export default ConversationList;
